import { render, staticRenderFns } from "./tevkifatkodu.vue?vue&type=template&id=1b656000&"
import script from "./tevkifatkodu.vue?vue&type=script&lang=js&"
export * from "./tevkifatkodu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports